import removeAccents from 'remove-accents';

export default (s) => {
  if (typeof s !== 'string') {
    return '';
  }

  return removeAccents(s);
};
